import { Environment } from '../app/interfaces';

export const environment: Environment = {
  production: false,
  authServerUrl: 'https://fresh-auth-pentest-311805066495.europe-west2.run.app'
};
